<template>
	<v-app>
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title>{{ credentials.admin ? "Admin Login" : "User Login" }}</v-toolbar-title>
								<v-spacer></v-spacer>
								<span>
									<v-btn icon large v-if="!credentials.admin" @click="credentials.admin = !credentials.admin">
										<v-icon>mdi-account-tie</v-icon>
									</v-btn>
									<v-btn icon large v-if="credentials.admin" @click="credentials.admin = !credentials.admin">
										<v-icon>mdi-account</v-icon>
									</v-btn>
								</span>
							</v-toolbar>
							<v-card-text>
								<v-form>
									<v-text-field v-if="createAccount" v-model="credentials.email" label="Email" name="Email" prepend-icon="mdi-email" type="text"></v-text-field>
									<v-text-field v-model="credentials.username" label="Username" name="Username" prepend-icon="mdi-account" type="text"></v-text-field>
									<v-text-field v-model="credentials.password" @submit="handleLogin"  id="password" label="Password" name="password" prepend-icon="mdi-lock" type="password"></v-text-field>
									<v-text-field v-if="credentials.admin" v-model="credentials.masterKey" id="masterKey" label="MasterKey" name="password" prepend-icon="mdi-lock" type="password"></v-text-field>
								</v-form>
								<div v-if="invalidCredentials" style="background:red;padding:20px;color:white;">
									<span>Invalid credentials</span>
								</div>
							</v-card-text>
							<v-card-actions>
								<span>
									<v-icon style="margin-left:20px">mdi-account-plus</v-icon> </span
								><v-switch style="margin-left:20px" v-model="createAccount" />
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="handleLogin">{{ createAccount ? "Create" : "Login" }}</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import {ParseAuthService, CommonService} from '../services'

export default {
	name: "Login",
	data() {
		return {
			invalidCredentials:false,
			createAccount: false,
			credentials: {
				email: "",
				username: "",
				password: "",
				masterKey: "v",
				admin: false,
			},
		};
	},
	computed: {},
	methods: {
		handleLogin() {
			if (this.createAccount) {
				CommonService.showLoading(true);
				ParseAuthService.signUp(this.credentials).then(()=>{
					CommonService.showLoading(false);

				}).catch(ex=>{
					console.log(ex);
					CommonService.showLoading(false);
				});
			} else {
				CommonService.showLoading(true);
				ParseAuthService.logIn(this.credentials)
					.then(() => {
						this.$router.push({
							name: this.credentials.admin ? "Admin": "Maintainer"
						})
						CommonService.showLoading(false);
					})
					.catch((e) => {
						this.invalidCredentials = true
						console.log(e);
						CommonService.showLoading(false);
					});
			}
		},
	},
};
</script>
